import { Component } from '@angular/core';
import { AuthService } from './util/service/auth/auth.service';

@Component({
  selector: 'app-root',
  template: `<app-toast></app-toast><router-outlet></router-outlet>`,
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'cosbots-form';

  constructor(private authService: AuthService) {}
}
